<template>
  <div>

    <v-row v-if="loading">
      <v-col cols="4">
        <v-sheet class="pa-4 rounded-lg">
          <v-skeleton-loader type="table-heading, divider, text@3"></v-skeleton-loader>
        </v-sheet>
        <v-sheet class="pa-4 rounded-lg mt-4">
          <v-skeleton-loader type="table-heading, divider, text@3"></v-skeleton-loader>
        </v-sheet>
      </v-col>
      <v-col cols="8">
        <v-sheet class="pa-4 rounded-lg">
          <v-skeleton-loader type="sentences, text@3, image"></v-skeleton-loader>
        </v-sheet>
      </v-col>
    </v-row>


    <template v-if="!loading">
      <v-row v-if="datasource.import_errors && datasource.import_errors.length > 0">
        <v-col>
          <v-sheet class="pa-4 rounded-lg">
              <h4>Importeer fouten</h4>
              <v-textarea
                  outlined
                  class="mb-0 text-body-2 transparent overflow-y-auto"
                  :rows="importErrorsRowsHeight"
                  :value="importErrors">
              </v-textarea>
              <v-btn class="mb-2"
                     block
                     depressed
                     color="secondary"
                     v-clipboard:copy="copyErrorsToClipboard()"
                     v-clipboard:success="onCopySuccess"
                     v-clipboard:error="onCopyError"
              >Kopieer foutmeldingen naar klembord</v-btn>
            </v-sheet>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-sheet class="pa-4 rounded-lg">
            <v-row>
              <v-col>
                <h4>Databron naam</h4>
                <div class="value">{{ datasource.name }}</div>
              </v-col>
            </v-row>
            <v-row v-if="datasource_type === 'map_features'">
              <v-col>
                <h4>Coordinaten systeem</h4>
                <div class="value">{{ field_crs_label[datasource.field_crs] }}</div>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <h4>Bronbestand</h4>
                <div class="value">
                  <v-icon>mdi-file-outline</v-icon>
                  <a href="#" @click.prevent="downloadFileWithApiKeyAuth(datasource.file.uri.url, datasource.file.filename)">{{ datasource.file.filename }}</a>
                  <v-progress-circular v-if="fileDownloadInProgress" indeterminate size="18" class="ml-2"></v-progress-circular>
                </div>
              </v-col>
            </v-row>
          </v-sheet>
        </v-col>
        <v-col>
          <v-sheet class="pa-4 rounded-lg">
            <h3>Databron exporteren</h3>
            <v-btn
                depressed
                color="primary"
                @click="showExportModal"
            >
              Export starten
            </v-btn>
          </v-sheet>
        </v-col>
      </v-row>
    </template>


    <v-dialog v-model="exportModal" max-width="800" persistent scrollable>
      <v-card>
        <v-card-text class="pt-6">
          <template v-if="!exportIsFinished">
            <p v-if="!isExporting">Deze actie exporteert alle items, inclusief alle mutaties die gedaan zijn via registraties.</p>
            <drupal-batch
                :batch-create-url="'api/datasource/'+datasource_id+'/export'"
                button-label="Exporteer databron"
                @batch-started="exportBatchStarted"
                @batch-created="exportBatchCreated"
                @batch-finished="exportBatchFinished"
            ></drupal-batch>
          </template>
          <p v-if="exportIsFinished">Export is voltooid. <v-btn depressed color="primary" :href="exportDownloadUrl"><v-icon left>mdi-download</v-icon> Download CSV bestand</v-btn></p>
        </v-card-text>
        <v-card-actions class="background-color">
          <v-btn
              depressed
              :color="isExporting ? 'error' : 'secondary'"
              :outlined="!isExporting"
              @click="closeExportModal"
          >
            <template v-if="isExporting">
              Stop export
            </template>
            <template v-else-if="exportIsFinished">
              Sluit venster
            </template>
            <template v-else>
              Annuleren
            </template>
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import axios from "axios";
import {mapGetters} from "vuex";
import normalize from "json-api-normalize";
import drupalBatch from "@/components/DrupalBatch";
import datasourceEntityHelpers from "@/mixins/datasourceEntityHelpers";

export default {
  components: {
    drupalBatch
  },
  mixins: [
    datasourceEntityHelpers,
  ],
  props: {
    datasource_type: null,
    datasource_id: null,
  },
  data() {
    return {
      api_base_url: process.env.VUE_APP_API_BASEURL,
      datasource: {},
      loading: true,
      isSaving: false,
      exportModal: false,
      isExporting: false,
      exportIsFinished: false,
      exportDownloadUrl: '',
      fileDownloadInProgress: false,
    }
  },
  computed: {
    ...mapGetters({User: "StateUser", CurrentClient: "CurrentClient"}),
    // Create a newline separated string from the import errors
    importErrors() {
      return this.datasource.import_errors ? this.datasource.import_errors.join('\n') : '';
    },
    importErrorsRowsHeight() {
      // Make height the same as the number of errors, with a max of 10 rows
      if (this.datasource.import_errors && this.datasource.import_errors.length > 0) {
        return Math.min(this.datasource.import_errors.length, 10);
      }
      return 1;
    },
  },
  mounted () {
    // Get registration from API
    this.getDataFromApi();
  },
  methods: {
    getDataFromApi () {
      this.loading = true
      // Fetch results from the API
      axios
          .get('jsonapi/eform_datasource/'+this.datasource_type+'/'+this.datasource_id)
          .then(response => {
            // Add normalized datasource
            this.datasource = normalize(response.data).get([
              'name',
              'import_errors',
              'field_crs',
              'file.filename',
              'file.uri'
            ])
            // this.updateForm(response.data);
            this.loading = false;
          })
          .catch(error => {
            console.log(error)
            this.errored = true
          })
          .finally(() => this.loading = false)
    },
    showExportModal() {
      this.exportModal = true
      this.exportIsFinished = false
    },
    closeExportModal() {
      this.exportModal = false
    },
    exportBatchStarted() {
      this.isExporting = true
      this.exportDownloadUrl = ''
    },
    exportBatchCreated(data) {
      if (data.data) {
        this.exportDownloadUrl = data.data.download_url
      }
    },
    exportBatchFinished() {
      this.isExporting = false
      this.exportIsFinished = true
    },
    copyErrorsToClipboard() {
      return this.importErrors;
    },
    onCopySuccess() {
      let $vm = this;
      $vm.$toast.success("Gekopieerd");
    },
    onCopyError() {
      let $vm = this;
      $vm.$toast.error("Kon niet kopieren.");
    },
    downloadFileWithApiKeyAuth(file_url, file_name) {
      const url = this.api_base_url + file_url;
      this.fileDownloadInProgress = true;

      axios.get(url, { responseType: 'blob' })
          .then(response => {
            // prefer provided filename, fallback to content-disposition
            let filename = file_name || this.getFilenameFromDisposition(response.headers['content-disposition']) || 'download';
            const blob = new Blob([response.data]);
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(link.href);
            this.$toast.success("Download gestart");
          })
          .catch(error => {
            console.error(error);
            this.$toast.error("Kon bestand niet downloaden.");
          })
          .finally(() => {
            this.fileDownloadInProgress = false;
          });
    },
    getFilenameFromDisposition(header) {
      if (!header) return null;
      // handle filename*=UTF-8'' encoded and filename="name"
      const fileNameStar = /filename\*=UTF-8''([^;]+)/i.exec(header);
      if (fileNameStar && fileNameStar[1]) return decodeURIComponent(fileNameStar[1]);
      const fileNameQuoted = /filename="?([^";]+)"?/i.exec(header);
      return fileNameQuoted ? fileNameQuoted[1] : null;
    },
  }
}
</script>

<style scoped>

</style>